define('gameday-device-interaction/lib/ios',['require','exports','module','./DeviceInteraction','app-url/app-url','jquery','device/device'],function(require,exports,module){
    var DeviceInteraction = require( "./DeviceInteraction" ),
        parseUrl= require( "app-url/app-url" ),
        $       = require('jquery'),
        device  = require( "device/device" )();


    var SEP     = "&",
        STRING  = "string",
        NUMBER  = "number";

    /**
     * IOS Interaction schema : 
     *          Safari (webview?)
     *     json = {
     *         "safariurl":url 
     *     }
     *         native video
     *     json = {
     *         "videourl" : url
     *         "mediaid"  : cid         
     *     }
     */


    function isStringish(maybeStringOrNumber) {
        return typeof maybeStringOrNumber === STRING || typeof maybeStringOrNumber === NUMBER;
    }

    function ensureString(thing){
        return isStringish(thing) ? thing : encodeURIComponent(JSON.stringify(thing));
    }

    function IOSDispatcher(){
        this.url = parseUrl();
        this.params = this.url.hashParams;
        if(this.params.json){
            this.params.json = decodeURIComponent(JSON.parse(this.params.json));
        }
    }

    IOSDispatcher.prototype.buildHash = function(){
        var key,
            ret = [],
            params = this.params;

        for (key in params) {
            ret.push(key + '=' + ensureString(params[key]));
        }

        this.url.setProperty('hash',ret.join(SEP))
        return this.url.hash;
    };

    IOSDispatcher.prototype.mergeKeys = function(params){
        if(params.json){
            params.json.timestamp = (new Date()).getTime();
        }
        return this.params=$.extend(this.params,params);
    };

    IOSDispatcher.prototype.publish = function(params){
        this.mergeKeys(params);
        this.buildHash();
        window.location.replace(this.url.toString());
    }

    function IOSInteraction(){
        this.dispatcher = new IOSDispatcher();
        IOSInteraction.superclass.constructor.call(this);
        this.url = parseUrl();
    }

    IOSInteraction.isDispatcherAvailable = device.is.ios;

    DeviceInteraction.spawn(IOSInteraction)
        .define({
            type    : "ios",
            video   : function(data){
                this.dispatcher.publish({
                    "json" : {
                        "videourl": data.url, 
                        "mediaid": data.vid || data.id
                    }
                });
                return true;
            },
            webview : function(data){
                this.dispatcher.publish({
                    "json" : {
                        safariurl : data.url
                    }
                });
                return true;
            },
            playercard : function(data){
                this.dispatcher.publish({
                    "json" : {
                        playerId    : data.playerId || data.pid,
                        playerCard  : true,
                        playerString: data.name || data.title 
                    }
                });
                return true;
            },
            share : function(data){
               this.dispatcher.publish({
                    "json" : {
                        "videourl": data.url, 
                        "mediaid": data.vid || data.id,
                        "shareable":true
                    }
                });
                return true;
            },
            mlbtv : function(data){
               this.dispatcher.publish({
                    "json" : {
                        "gamedayLink": data.gid, 
                        "contentid": data.feed,
                        "eventid"  : data.feed
                    }
                });
                return true;
            }
        });
    return IOSInteraction;
});
